<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPlanDeger from "@/models/StrPlanDeger"; 
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  mixins: [Api, Sabit, StrPlanDeger],
  props:["DonemId","TabloId","Tablodetayid","BirimId"],
  data() {
    return {
      FormData: {  
            Id: "",
            Tabloid: 0,
            Tablodetayid: "",
            Donemid: 0,
            BirimId: null,
            Sapmanedeni: "",
            Alinacakonlem: "",
            Ilgililik: "",
            Etkililik: "",
            Etkinlik: "",
            Surdurulebilirlik: "",
            Deleted: false,},
      BosData: {  
            Id: "",
            Tabloid: 0,
            Tablodetayid: "",
            Donemid: 0,
            BirimId: null,
            Sapmanedeni: "",
            Alinacakonlem: "",
            Ilgililik: "",
            Etkililik: "",
            Etkinlik: "",
            Surdurulebilirlik: "",
            Deleted: false,},

       editor: ClassicEditor,
      editorData:"",
      content: "<h1>Some initial content</h1>",

      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
    };
  },
  components: {
    Loader,
      ckeditor: CKEditor.component
  },
  watch: {
       Tablodetayid() {

               this.Get();
    },

  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        if (this.FormData.Id == null || this.FormData.Id == "") { 

           this.$delete(this.FormData, "Id");

           this.Post("StrPlanDeger", this.FormData).then((res) => {
             if (res) {

                  this.$bvModal.hide("degergiris");
                  this.$emit("TableUpdate");
             }

           });

        } else {

   
         
         this.Update("StrPlanDeger", this.FormData).then((res) => {
              if (res) {
                this.$emit("TableUpdate");
                this.$bvModal.hide("degergiris");
              }
         });

        }
      }
    },
   Get(){ 
             let Page= {
          PageNumber: "1",
          PageSize: "9999"
        }  
            this.FormData = Object.assign({}, this.BosData);

            

          if(this.Tablodetayid!=null && this.Tablodetayid!=""){
          
              let filtrele = "&DonemId=" + this.DonemId+"&TabloId=" + this.TabloId+"&Tablodetayid=" + this.Tablodetayid + "&BirimId=" + this.BirimId;
              this.ActionsFilterGet({Service:"StrPlanDeger", Page:Page, Filter:filtrele}).then((res) => {   

              if (res.Data.length>0){
                                                 
                  this.FormData = res.Data[0];
              
              } else {


                  this.FormData = Object.assign({}, this.BosData);

                  this.FormData.Donemid=this.DonemId;
                  this.FormData.BirimId=this.BirimId;
                  this.FormData.Tabloid=this.TabloId;
                  this.FormData.Tablodetayid=this.Tablodetayid; 
           
              }


              }); 

          } else {

                 this.FormData = Object.assign({}, this.BosData);

                 this.FormData.BirimId=this.BirimId;
                  this.FormData.Donemid=this.DonemId;
                  this.FormData.Tabloid=this.TabloId;
           


          }

         
    }
  },
  created(){
    this.FormData = Object.assign({}, this.BosData);
    this.Get();
  }
};
</script>

<template>
  <Loader>



<b-modal id="degergiris" size="xl" title-class="font-18" hide-footer>
    <div class="row">
      <div class="col-12">

        <h4>  {{this.$t('StrPlanDeger.AddEditAlt.Title')}} </h4>
        <div class="card">

          <div class="card-body">
            <h4 class="card-title">{{this.$t('StrPlanDeger.AddEditAlt.Ilgililik')}}</h4>
            <!-- Editor -->
            <ckeditor v-model="FormData.Ilgililik" :editor="editor"></ckeditor>
          </div>

          <div class="card-body">
            <h4 class="card-title">{{this.$t('StrPlanDeger.AddEditAlt.Etkililik')}}</h4>
            <!-- Editor -->
            <ckeditor v-model="FormData.Etkililik" :editor="editor"></ckeditor>
          </div>
  <!--       <div class="card-body">
            <h4 class="card-title">{{this.$t('StrPlanDeger.AddEditAlt.Etkinlik')}}</h4>
            Editor
            <ckeditor v-model="FormData.Etkinlik" :editor="editor"></ckeditor>
          </div>

          <div class="card-body">
            <h4 class="card-title">{{this.$t('StrPlanDeger.AddEditAlt.Surdurulebilirlik')}}</h4>
             Editor
            <ckeditor v-model="FormData.Surdurulebilirlik" :editor="editor"></ckeditor>
          </div> -->  

    <div  align="center"  class="button-items">
      <button type="button" @click="onSubmit()" class="btn btn-primary">
        {{this.$t('StrPlanDeger.AddEditAlt.BtnKaydet')}}</button>
    </div>
    <br>

        </div>

      </div>
    </div>
 </b-modal>


  </Loader>
</template>
